import { CompanyFilter } from "../../../../../legacy/types/companyFilter";

export const useCompanyMatchLabel = (filter: CompanyFilter["companyMatch"]) => {
  if (!filter) return "";

  if (filter.fileId && !filter.lastMatched) {
    return "Processing...";
  }

  return `${filter.matchedRows} of ${filter.totalRows} matched`;
};
